import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Configuration schema version for compatibility.
 */
export const schema = z.string();

export type Version = z.infer<typeof schema>;

export const definition = define({
  key: 'version',
  schema,
  label: 'Version',
  description: 'Configuration schema version for compatibility (e.g., "1.0.0").',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.METADATA.key,
  writableAtLevels: [
    LEVELS.HOPDRIVE,
    LEVELS.REGION,
    LEVELS.ORGANIZATION,
    LEVELS.CUSTOMER,
    LEVELS.WORKFLOWSET,
    LEVELS.RATERULEGROUP,
    LEVELS.MOVE,
  ],
  readableByRoles: [ROLES.ADMIN],
});
